export function sendEvent(event, eventData=null){
    if(!eventData){
        eventData = {};
    }
    eventData['user'] = SessionManager.login ?? "";
    eventData['server'] = window['_apiEndpoint'];

    if(window['gtag']) {
        if(window.location.hostname === "silkplm.com") {
            try {
                let gtag = window['gtag'];
                let openTag = SessionManager.isOpen() ? "o:" : "e:";
                gtag('event', "s" + openTag + event, eventData);
            } catch (e) {
                console.log(e);
            }
        } else {
            console.log(`Emulating gtag: ${event}`);
        }
    }
}